import { forwardRef, useId, type InputHTMLAttributes } from 'react';

import { Input as InputPrimitive } from './shadcn/input';
type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  /** Defined for numeric settings; an empty string reserves the same unit cell. */
  unit?: string;
};

/** className and ref target the native input, including when the unit wrapper is present. */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  function Input({ unit, ...props }, ref) {
    const unitId = useId();
    if (unit === undefined) return <InputPrimitive ref={ref} {...props} />;
    const describedBy = [props['aria-describedby'], unit ? unitId : undefined].filter(Boolean).join(' ') || undefined;
    return (
      <div data-slot="input-unit" className="grid w-full min-w-0 max-w-72 grid-cols-[minmax(0,1fr)_--spacing(16)] items-center gap-x-2">
        <InputPrimitive ref={ref} {...props} aria-describedby={describedBy} />
        <span id={unit ? unitId : undefined} aria-hidden={unit ? undefined : true} data-slot="input-unit-label" className="min-w-0 break-words text-left text-ui text-muted-foreground">{unit}</span>
      </div>
    );
  },
);
